/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TextField, Grid } from '@material-ui/core';
import { Button } from 'react-bootstrap';
import moment from 'moment';
import Fieldset from '../../../../SharedModules/Fieldset/Fieldset';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import { TotalDollersPaidTableHeads } from './TableHead';

import {
  getTotalDollerPaidReport,
  setCheckNumber,
  setErrorList,
} from '../Store/actions';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import Spinner from '../../../../SharedModules/Spinner/Spinner';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import {
  CHECK_NUMBER_REQUIRED,
  CHECK_NUMBER_VALID,
  NO_DATA,
  NO_DATA_TO_DISPLAY,
} from '../../../../SharedModules/Errors/constantMessageData';
import { tabHighLigther } from '../../../../SharedModules/utilities/utilities';

const TotalDollersPaid = (props) => {
  const dispatch = useDispatch();

  const { isLoading, searchResult, errorList, checkNumber } = useSelector(
    (state) => state?.sharedState?.TotalDollerPaidReducer
  );

  const [rows, setRows] = React.useState([]);
  const [fullScreenView, setFullScreenView] = React.useState(false);
  // const [errorList, setErrorList] = React.useState([]);
  // const [checkNumber, setCheckNumber] = React.useState('');
  const [searchClicked, setSearchCicked] = React.useState(false);
  const [filteredRows, setFilteredRow] = React.useState([]);

  // on scroll default top level
  const handleScrollToEvent = () => {
    window.scrollTo(0, 0);
  };

  React.useEffect(() => {
    handleScrollToEvent();
  }, []);

  React.useEffect(() => {
    let data = searchResult || [];
    data = searchResult.map((item) => {
      return {
        ...item,
        checkAmount: parseFloat(item.checkAmount.toFixed(2)),
        allocatedAmt: parseFloat(item.allocatedAmt.toFixed(2)),
      };
    });
    setRows(searchResult);
    if (searchClicked && searchResult.length === 0) {
      dispatch(
        setErrorList([
          {
            field: 'noData',
            message: NO_DATA_TO_DISPLAY,
          },
        ])
      );
    }
  }, [searchResult]);

  React.useEffect(() => {
    if (errorList.length > 0) {
      tabHighLigther('/totaldollarspaid', true);
    } else {
      tabHighLigther('/totaldollarspaid', false);
    }
  }, [errorList]);

  // Function to toggle fullscreen view of table
  const changeFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };
  const validateInputs = () => {
    const localErrors = [];
    const regex = /^[1-9][0-9]*$/;
    if (checkNumber.trim().length === 0) {
      localErrors.push({
        field: 'checkNumber',
        message: CHECK_NUMBER_REQUIRED,
      });
    }
    // if (checkNumber.trim().length > 0) {
    //   if (!regex.test(checkNumber)) {
    //     localErrors.push({
    //       field: 'checkNumber',
    //       message: CHECK_NUMBER_VALID,
    //     });
    //   }
    // }
    return localErrors;
  };

  const handleSearchClick = () => {
    const localErrors = validateInputs();

    dispatch(setErrorList(localErrors));
    if (localErrors.length === 0) {
      setSearchCicked(true);
      dispatch(
        getTotalDollerPaidReport({
          checkNumber,
        })
      );
    }
  };

  // To update totals when no condition matches from filter
  const [filterApply, setFilterApply] = React.useState(false);
  const getFilterApply = (filterApplied) => {
    setFilterApply(filterApplied);
  };

  /*
    Below threee functions are for calculating data of table bottom pinned row
  */
  const sum = (property) => {
    const displayedRows = filterApply ? filteredRows : rows;
    if (property === 'checkLogNum') {
      const data = displayedRows.length;
      return `${data} Checks`;
    }
    const data = displayedRows?.reduce((accumulator, object) => {
      return (
        accumulator + (object[property] ? parseFloat(object[property]) : null)
      );
    }, 0);
    return data ? parseFloat(data.toFixed(2)) : 0.0;
  };
  const createData = (count) => {
    const result = [];
    for (let i = 0; i < count; i += 1) {
      result.push({
        isBottomRow: true,
        checkAmount: sum('checkAmount'),
        depositDate: 'Total Check:',
        allocatedAmt: sum('allocatedAmt'),
        receiptNumber: 'Total Allocated Amount:',
      });
    }
    return result;
  };
  const pinnedBottomRowData = useMemo(() => {
    return createData(1, 'Bottom');
  }, [rows, filteredRows, filterApply]);

  const onFilterChanged = (rowData, type) => {
    setFilteredRow(rowData);
  };
  return (
    <div className="tabs-container">
      <Spinner load={isLoading} />
      <CustomSeparator parent1="State Reports" parent2="Total Dollars Paid" />
      <DisplayErrorMessages errorMessages={errorList?.map((l) => l.message)} />
      <div className="tab-body">
        {!fullScreenView && (
          <>
            <div className="row">
              <div className="col-12  ">
                <div className="form-wrapper p-0 mt-2">
                  <div className="mui-custom-form input-md field-xl">
                    <div className="row mb-2">
                      <div className="col-4">
                        <Fieldset label="Check Number" required>
                          <div className="form-wrapper p-0 mt-n3">
                            <div className="mui-custom-form input-md field-xl">
                              <Grid container spacing={2} alignItems="center">
                                <Grid item xs={12} md={12}>
                                  <TextField
                                    label="Total Dollar"
                                    id="totaldollar"
                                    data-testid="total-doller-check-number"
                                    placeholder=""
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                    required
                                    value={checkNumber}
                                    onChange={(e) => {
                                      dispatch(setCheckNumber(e.target.value));
                                      dispatch(setErrorList([]));
                                    }}
                                    onBlur={() =>
                                      dispatch(setErrorList(validateInputs()))
                                    }
                                    error={
                                      errorList?.filter(
                                        (error) => error.field === 'checkNumber'
                                      )?.length > 0
                                        ? 'mandate-fields'
                                        : ''
                                    }
                                    helperText={
                                      errorList?.find(
                                        (error) => error.field === 'checkNumber'
                                      )?.message
                                    }
                                    className="mandate-fields frr-display-hidden-label"
                                  />
                                </Grid>
                              </Grid>
                            </div>
                          </div>
                        </Fieldset>
                      </div>
                    </div>
                    <div className="row" style={{ marginTop: 30 }}>
                      <div className="btn-wrapper col-12">
                        <Button
                          data-testid="total-doller-serach-button"
                          onClick={handleSearchClick}
                          className="btn btn-success btn-search float-right"
                        >
                          <SVGComponent iconName="Icon-search" /> Search
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        {rows.length > 0 && (
          <div className="row" style={{ marginTop: 15 }}>
            <div
              className="unallocated bottom-pinned-bold"
              style={{ width: '100vw' }}
            >
              <TableGridWithFeatures
                gridHeight={viewPortHeight_355}
                columnDefs={TotalDollersPaidTableHeads}
                rowData={rows}
                data-testid="onEditingStopped"
                enterMovesDown
                showResetFilter={false}
                defaultCol={{
                  wrapHeaderText: true,
                  autoHeaderHeight: true,
                }}
                isScrollOn
                hideTotalCount={false}
                exportFile
                fileName="TotalDollarsPaid "
                reportName="Total Dollars Paid Report"
                fullScreenView={fullScreenView}
                handleFullScreenViewClick={changeFullScreenView}
                pinnedBottomRowData={pinnedBottomRowData}
                onFilterData={onFilterChanged}
                getFilterApply={getFilterApply}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TotalDollersPaid;
